import {useEffect} from 'react';
import * as d3 from "d3";
import deviceIcon from '../img/deviceIcon.svg';
import ActiveIncident from '../img/ActiveIncident.svg';
import MitigatedIncident from '../img/MitigatedIncident.svg';
import ResolvedIncident from '../img/ResolvedIncident.svg';
import UnknownIncident from '../img/UnknownIncident.svg';
import ParentChild from '../img/ParentChild.jpeg';

// <Summary>
// Type - React Functional Component 
// Description - the Legend Component
// </Summary>
const Legend =() => {
  
  useEffect(()=>{
    drawLegend();
  },[])
  
  // <Summary>
  // Type - Function
  // Description - function that draws the legend
  // </Summary>
  const drawLegend = () =>{
    var div = d3.select('.legendContainer');
    var width = div.node().getBoundingClientRect().width*(0.95);
    var height = div.node().getBoundingClientRect().height*(0.85);
    
    var Svg = d3.select(".Legend").attr('height',height).attr('width',Math.max(width,210))

    // Node types,text colors and Icons
    var nodes = ["Device","Active Incident", "Mitigated Incident","Resolved Incident","Status Unknown"]
    var nodecolors = ['#1f77b4', 'red', '#ff8c00','green','gray']
    var nodeIcons = [deviceIcon,ActiveIncident,MitigatedIncident,ResolvedIncident,UnknownIncident]

    // Link types and Colors
    var links = ["Device Incident", "CDP Neighbors", "LLDP Neighbors", "ISIS Neighbors"]
    var linkcolors = ['blue', "#004b50","#5c005c", "#00bcf2" ]

    // Current and Selected Nodes
    var selection = ["Current Node","Parent Incident"]
    var selectioncolors = ['black', '#3279a8']
    
    
    // Adds all the node icons
    Svg.selectAll("nodes")
      .data(nodes)
      .enter()
      .append("image")
        .attr("x", width/3.5-20)
        .attr("y", function(d,i){ return height*(0.05)+ i*height*(0.075)}) 
        .attr('xlink:href', (d,i)=> nodeIcons[i])
        .attr('width', '40')
        .attr('height', '20')
    
    // Adds all the node labels
    Svg.selectAll("nodelabels")
      .data(nodes)
      .enter()
      .append("text")
        .attr("x", width/3.5+30)
        .attr("y", function(d,i){ return height*(0.08) + i*height*(0.075)}) 
        .style("fill", function(d,i){ return nodecolors[i]})
        .text(function(d){ return d})
        .attr('font-size',15)
        .attr("text-anchor", "left")
        .style("alignment-baseline", "middle")
    
    // Adds a line for each link
    Svg.selectAll("links")
      .data(links)
      .enter()
      .append("line")
        .attr("x1", width/3.5-15)
        .attr("y1", function(d,i){ return height*(0.45) + i*height*(0.075)})
        .attr("x2", width/3.5+15) 
        .attr("y2", function(d,i){ return height*(0.45) + i*height*(0.075)})
        .style("stroke", function(d,i){ return linkcolors[i]})
        
    // Adds labels for each link
    Svg.selectAll("linklabels")
      .data(links)
      .enter()
      .append("text")
        .attr("x", width/3.5+30)
        .attr("y", function(d,i){ return height*(0.45) + i*height*(0.075)}) 
        .style("fill", function(d,i){ return linkcolors[i]})
        .text(function(d){ return d})
        .attr('font-size',15)
        .attr("text-anchor", "left")
        .style("alignment-baseline", "middle")

    // Add image for parent-child link
    Svg.selectAll('ParentChild')
      .data(['Child to Parent'])
      .enter()
      .append("image")
        .attr("x", width/3.5-15)
        .attr("y", function(d,i){ return height*(0.73)+ i*height*(0.075)}) 
        .attr('xlink:href', ParentChild)
        .attr('width', '35')
        .attr('height', '10')
    
    // Adds label for the parent-child link
    Svg.selectAll("ParentChildLabel")
      .data(['Child to Parent'])
      .enter()
      .append("text")
        .attr("x", width/3.5+30)
        .attr("y", function(d,i){ return height*(0.75) + i*height*(0.075)}) 
        .style("fill", 'green')
        .text(function(d){ return d})
        .attr('font-size',15)
        .attr("text-anchor", "left")
        .style("alignment-baseline", "middle")
    
    // Adds icons for selected and parent node 
    Svg.selectAll("selection")
        .data(selection)
        .enter()
        .append("circle")
        .attr("cx", width/3.5)
        .attr("cy", function(d,i){ return height*(0.82)+ i*height*(0.075)}) 
        .attr("r", 7)
        .style("fill", 'white') 
        .attr('stroke-dasharray', (d) =>{
          if(d === 'Parent Incident')
            return (14,3.5);
        })
        .attr('stroke', (d,i)=>{
          return selectioncolors[i]; 
        })
        .attr('stroke-width', 3);
    
    // Adds label for selected and parent node
    Svg.selectAll("selectionlabels")
        .data(selection)
        .enter()
        .append("text")
        .attr('font-size',15)
          .attr("x", width/3.5+30)
          .attr("y", function(d,i){ return height*(0.82) + i*height*(0.075)}) 
          .style("fill", function(d,i){ return selectioncolors[i]})
          .text(function(d){ return d})
          .attr("text-anchor", "left")
          .style("alignment-baseline", "middle")
        
  }
  return (
    <div className="legendContainer" style={{height:'30vh', width:'100%',marginTop:'2vh',boxShadow: "0 4px 12px 0 rgba(0, 0, 0, 0.2), 0 6px 12px 0 rgba(0, 0, 0, 0.19)",overflow:'auto'}}>
        <div style={{width:'100%',textAlign:'center',background:'#e1dfdd',height:'3vh'}}>
            <h3 style={{marginTop:'0px',paddingTop:'0.5vh'}}>Legend</h3>
        </div>
        <svg className="Legend"></svg>
    </div>
  );
}

export default Legend;
